'use-strict'

import React from 'react'
import Spinner from './Spinner'

const LoadingOverlay = ({ loading = false, children }) => {
    return (
        <div style={{ position: 'relative' }}>
            <div style={{
                filter: loading ? 'blur(2px)' : 'none',
                pointerEvents: loading ? 'none' : 'auto',
                transition: 'filter 0.3s ease',
                opacity: loading ? 0.6 : 1,
            }}>
                {children}
            </div>
            {loading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10,
                }}>
                    <Spinner show={true} />
                </div>
            )}
        </div>
    )
}

export default LoadingOverlay
